<template>
  <div class="wrap">
    <div class="slide slide1">
      <img class="img" src="@assets/imgs/productM/01.png" />
      <!-- <div class="title">
        <div class="last">
          {{ $t("product.ORI") }}
        </div>
      </div> -->
      <ul class="btnbox">
        <li class="see-video-btn">
          <a href="#par" style="color: white">{{ $t("slides.全部参数") }}</a>
        </li>
        <li class="see-video-btn" @click="gotrial">
          {{ $t("index.预约试驾") }}
        </li>
      </ul>
      <ul class="bottom">
        <li>
          <p><span class="number">73</span>Kg</p>
          <p>{{ $t("slides.整车重量设计") }}</p>
          <p>{{ $t("slides.轻量化灵动") }}</p>
        </li>
        <li>
          <p><span class="number">100</span>Km</p>
          <p>{{ $t("slides.高效续航") }}</p>
          <p>{{ $t("slides.3小时快速充电") }}</p>
        </li>
        <li>
          <p><span class="number">420</span>Nm</p>
          <p>{{ $t("slides.最大扭矩") }}</p>
          <p>{{ $t("slides.动力充沛") }}</p>
        </li>
      </ul>
    </div>

    <div class="slide slide2">
      <img class="img" src="@assets/imgs/productM/02.png" alt="" />

      <div class="desc-wrap">
        <div class="desc1">
          <div>{{ $t("slides.为探索而生") }}</div>
          <div>{{ $t("slides.创造无限的可能，创造自由的骑行") }}</div>
        </div>
      </div>
    </div>

    <div class="slide slide3">
      <div class="right">
        <img
          :src="require('@assets/imgs/productM-slide3/' + slide3.num + '.png')"
        />
        <p class="bold">
          {{ $t("slides.极简设计") }}-{{ $t("slides.次世代外观") }}
        </p>
        <div class="lable">
          {{ $t("product.ORI") }}
        </div>
      </div>
      <div class="left" ref="rotate">
        <div
          @touchstart="slide3.num = '2'"
          :class="slide3.num == '2' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.前轮") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '3'"
          :class="slide3.num == '3' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.后轮") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '4'"
          :class="slide3.num == '4' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.前避震") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '5'"
          :class="slide3.num == '5' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.后避震") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '6'"
          :class="slide3.num == '6' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.电机") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '7'"
          :class="slide3.num == '7' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.电控") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '8'"
          :class="slide3.num == '8' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.电芯") }}
          </p>
        </div>
        <div
          @touchstart="slide3.num = '9'"
          :class="slide3.num == '9' ? 'active' : ''"
          :style="{ width: `${slide3.width}%` }"
        >
          <p>
            {{ $t("slides.仪表") }}
          </p>
        </div>
      </div>
    </div>

    <div class="slide slide4">
      <div class="box">
        <div class="lable">{{ $t("slides.灿若星空 设计理念") }}</div>
        <div class="title">
          <p>{{ $t("slides.轻量化") }}</p>
          <div>{{ $t("slides.前后配重比例50：50") }}</div>
        </div>
        <img src="@assets/imgs/productM/03.png" />
        <div class="title">
          <p style="padding-top: 5vw">{{ $t("slides.骑行三角点") }}</p>
          <div style="padding-top: 5vw">
            {{ $t("slides.反复进行越野实验的人体工程学三角参数") }}
          </div>
        </div>
        <img src="@assets/imgs/productM/04.png" />
        <div class="title">
          <p>{{ $t("slides.操控性") }}</p>
          <div>
            {{ $t("slides.26°前倾角，780mm宽车把，指向灵活，直线稳定") }}
          </div>
        </div>
        <img src="@assets/imgs/productM/05.png" />
      </div>
    </div>

    <div class="slide slide5">
      <div class="top">
        <div class="title">{{ $t("slides.星空深邃 越野性能") }}</div>
        <img src="@assets/imgs/productM/06.png" />
        <p>
          <span class="bold">{{ $t("slides.锻造双翼梁复合车架") }}</span
          ><br /><span>{{ $t("slides.全铝车架，轻盈，提升操控感受") }}</span>
        </p>
        <!-- <hr /> -->
      </div>
      <div class="bottom">
        <div>
          <img src="@assets/imgs/productM/07.png" />
          <p>
            <span class="bold">{{ $t("slides.四连杆后避震系统") }}</span
            ><br />
            <span>{{
              $t(
                "slides.独特的四连杆式避震系统可以在不同下压力下均获得良好的抓地力和避震能力"
              )
            }}</span>
          </p>
        </div>
        <div>
          <img src="@assets/imgs/productM/08.png" />
          <p>
            <span class="bold">{{ $t("slides.刹车") }}</span
            ><br />
            <span>{{
              $t(
                "slides.一体式四活塞卡钳，配合203*28加厚碟盘，提供强大刹车性能"
              )
            }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="slide slide9">
      <img
        class="img"
        src="https://file.modehoist.com/gowow/website/app/CN.png"
        alt=""
        v-if="isCN"
      />
      <img
        class="img"
        src="https://file.modehoist.com/gowow/website/app/EN.png"
        alt=""
        v-else
      />

      <div class="desc-wrap">
        <div class="desc1">
          {{ $t("slides.三大模式 - 动力强劲") }}
        </div>
        <div class="desc2">
          <div>
            <img
              src="https://file.modehoist.com/gowow/website/app/icon-A.png"
              alt=""
            />
            <p>{{ $t("slides.绵羊模式") }}</p>
          </div>
          <div>
            <img
              src="https://file.modehoist.com/gowow/website/app/icon-B.png"
              alt=""
            />
            <p>{{ $t("slides.猎犬模式") }}</p>
          </div>
          <div>
            <img
              src="https://file.modehoist.com/gowow/website/app/icon-C.png"
              alt=""
            />
            <p>{{ $t("slides.猎豹模式") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="slide slide10">
      <div class="desc1">
        {{ $t("slides.可适应多种场景") }}
      </div>
      <div class="desc2">
        <div>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/backdrop%402x.png"
            alt=""
          />
          <p>{{ $t("slides.公路") }}</p>
        </div>
        <div>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/backdrop%402x%282%29.png"
            alt=""
          />
          <p>{{ $t("slides.林道") }}</p>
        </div>
        <div>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/backdrop%402x%281%29.png"
            alt=""
          />
          <p>{{ $t("slides.沙漠") }}</p>
        </div>
        <div>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/backdrop%402x%283%29.png"
            alt=""
          />
          <p>{{ $t("slides.泥路") }}</p>
        </div>
      </div>
    </div>
    <div class="slide slide11">
      <img
        class="img"
        src="https://file.modehoist.com/gowow/website/ori_detail/backdrop%402x%284%29.png"
        alt=""
      />
      <div class="desc-wrap">
        <div class="desc1">
          <p>
            {{ $t("slides.可拆卸替换电池") }}
          </p>
          <div style="margin: 10px 0">
            {{ $t("slides.大电池，更持久的续航") }}
          </div>
          <div>{{ $t("slides.三年质保") }}</div>
          <div>2.8kWh</div>
        </div>
      </div>
    </div>
    <div class="slide slide6">
      <div class="title">{{ $t("slides.流星电掣 动力系统") }}</div>

      <div class="bottom">
        <div>
          <img src="@assets/imgs/productM/09.png" />
          <p>
            <span class="bold">{{ $t("slides.高容量电池芯组") }}</span
            ><br /><span>{{ $t("slides.自研锂电池芯，21700电芯") }}</span>
          </p>
        </div>
        <div class="frist">
          <img src="@assets/imgs/productM/10.png" />
          <p>
            <span class="bold">{{ $t("slides.高性能电机") }}</span
            ><br />
            <span>{{
              $t("slides.PMSM永磁同步电机，最终轮端扭矩420Nm，最高速度") 
            }}  100 km/h</span>
          </p>
        </div>
        <div>
          <img src="@assets/imgs/productM/11.png" />
          <p>
            <span class="bold">{{ $t("slides.高效能电控") }}</span
            ><br />
            <span>{{
              $t(
                "slides.具备四种动力模式可选，动力曲线可自定义调整、四种场景模式选择、速度自定义、boost一键冲刺等多种功能"
              )
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <DownLoadM />

    <div class="slide slide7">
      <img src="@assets/imgs/productM/12.png" />
      <div>
        <p class="title title1">{{ $t("slides.车主权益") }}</p>
        <p class="title2">{{ $t("slides.整车质保1年") }}</p>
        <p class="title3">{{ $t("slides.俱乐部活动") }}</p>
      </div>
    </div>
    <div class="slide slide12">
      <div class="title">{{ $t("slides.包含内容") }}</div>
      <div class="desc1">
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/manual%402x.png"
            alt=""
          />
          <p>{{ $t("index.产品说明书") }}</p>
        </li>
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/icon%402x.png"
            alt=""
          />
          <p>{{ $t("slides.充电器") }}</p>
        </li>
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/mirror.png"
            alt=""
          />
          <p>{{ $t("slides.后视镜") }}</p>
        </li>
      </div>
      <div class="desc2">
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/icon%402x%281%29.png"
            alt=""
          />
          <p>{{ $t("slides.左脚踏板") }}</p>
        </li>
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/Rectangle%402x.png"
            alt=""
          />
          <p>{{ $t("slides.右脚踏板") }}</p>
        </li>
      </div>
      <div class="desc1">
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/wrench%402x.png"
            alt=""
          />
          <p>13mm</p>
        </li>
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/wrench%402x.png"
            alt=""
          />
          <p>14mm</p>
        </li>
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/wrench%402x.png"
            alt=""
          />
          <p>15mm</p>
        </li>
      </div>
      <div class="desc2">
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/icon%402x%282%29.png"
            alt=""
          />
          <p>4mm</p>
        </li>
        <li>
          <img
            src="https://file.modehoist.com/gowow/website/ori_detail/icon%402x%282%29.png"
            alt=""
          />
          <p>5mm</p>
        </li>
      </div>
    </div>
    <div class="slide slide8">
      <div class="title">{{ $t("slides.基本参数") }}</div>
      <div class="icon">
        <div>
          <li><img src="@assets/imgs/product/Sit high_icon.png" /></li>
          <p class="bold">{{ $t("slides.座高") }}</p>
          <p class="text">890mm</p>
        </div>
        <div>
          <li><img src="@assets/imgs/product/Battery_icon.png" /></li>
          <p class="bold">{{ $t("slides.电池容量") }}</p>
          <ul class="text">
            <li>2.8kWh</li>
          </ul>
        </div>
        <div>
          <li><img src="@assets/imgs/product/weight_icon.png" /></li>
          <p class="bold">{{ $t("slides.整车质量") }}</p>
          <p class="text">73kg</p>
        </div>
        <div>
          <li><img src="@assets/imgs/product/tyre_icon.png" /></li>
          <p class="bold">{{ $t("slides.轮胎") }}</p>
          <ul class="text">
            <li>{{ $t("slides.前 70/100-19") }}</li>
            <li>{{ $t("slides.后 350-18") }}</li>
          </ul>
        </div>
      </div>
      <div class="content">
        <div>
          <li>
            <p class="bold">1900mm/780mm/
              
              1100mm</p>
            <p>{{ $t("slides.长宽高") }}</p>
          </li>
        </div>
        <div>
          <li>
            <p class="bold">280mm</p>
            <p>{{ $t("slides.离地间隙") }}</p>
          </li>
          <li>
            <p class="bold">100kg</p>
            <p>{{ $t("slides.最大载重") }}</p>
          </li>
          <li>
            <p class="bold">1275mm</p>
            <p>{{ $t("slides.轴距") }}</p>
          </li>
        </div>
        <div>
          <li>
            <p class="bold">210mm</p>
            <p>{{ $t("slides.前轮行程") }}</p>
          </li>
          <li>
            <p class="bold">210mm</p>
            <p>{{ $t("slides.后轮行程") }}</p>
          </li>
          <li>
            <p class="bold">9kW</p>
            <p>{{ $t("slides.峰值功率") }}</p>
          </li>
        </div>
      </div>
      <div class="content">
        <div>
          <li>
            <p class="bold">100km</p>
            <p>{{ $t("slides.续航里程") }}</p>
          </li>
          <li>
            <p class="bold">420Nm</p>
            <p>{{ $t("slides.驱动轮端扭矩") }}</p>
          </li>
        </div>
        <div>
          <li>
            <p class="bold">100km/h</p>
            <p>{{ $t("slides.最高速度") }}</p>
          </li>
          <li>
            <p class="bold">55°@10km/h</p>
            <p>{{ $t("slides.爬坡角度") }}</p>
          </li>
        </div>
        <div>
          
          <li>
            <p class="bold" >
                80%: 2h @220V     
            </p>
            <p>{{ $t("slides.充电时间") }}</p>
          </li>
        </div>
        
      </div>
    </div>
    <FloatBall />
  </div>
</template>

<script>
import DownLoadM from "../../../../index/components/DownLoadM";
import { goto } from "@utils/goto";
import { mapState } from "vuex";
import FloatBall from "@/pages/product/FloatBall";
export default {
  components: {
    DownLoadM,
    FloatBall,
  },
  computed: {
    ...mapState(["lang"]),
    isCN() {
      return this.lang === "zh-CN";
    },
  },
  data() {
    return {
      tabPosition: "left",
      slide3: {
        num: "1",
        width: 45,
      },
    };
  },
  methods: {
    gotrial() {
      goto("/trial");
    },
  },
  mounted() {},
  watch: {
    isCN: function (val) {
      if (val) {
        this.slide3.width = 24;
        // this.$refs.rotate.style.width = "60%";
      } else {
        this.slide3.width = 45;
        // this.$refs.rotate.style.width = "100%";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@assets/styles/vars.scss";
@import "~@assets/styles/mixin.scss";
@import "~@assets/styles/func.scss";
img {
  vertical-align: top;
}
li {
  list-style: none;
}
.slide1 {
  position: relative;
  display: flex;
  flex-direction: column;
  > .img {
    width: 100%;
    height: auto;
  }
  > .title {
    width: 100vw;
    text-align: center;
    position: absolute;
    top: 30%;
    color: #ffffff;
    text-transform: uppercase;

    .last {
      font-size: px2rem(16px);
      font-family: PingFang-SC-Medium;
      color: #fff;
      width: 100%;
    }
    .first {
      font-size: px2rem(82px);
      font-family: PingFang-SC-Heavy;
      font-weight: normal;
      font-weight: bold;
      // font-style: italic;
      margin-bottom: px2rem(4px);
    }
  }
  .btnbox {
    color: #ffffff;
    display: flex;
    width: 100%;
    justify-content: center;
    position: absolute;
    top: 70%;
    .see-video-btn {
      cursor: pointer;
      margin: 0 px2rem(5px);
      @include flex-center("row");
      width: px2rem(150px);
      height: px2rem(30px);
      border: px2rem(1px) solid rgba(255, 255, 255, 1);
      border-radius: px2rem(20px);
      font-size: px2rem(13px);
      font-weight: 500;
      font-family: PingFang-SC-Medium;
    }
  }
  .bottom {
    width: 100%;
    position: absolute;
    top: 80%;
    color: #ffffff;
    display: flex;
    justify-content: center;
    li {
      width: 30%;
      text-align: center;
      font-size: px2rem(13px);
      font-family: PingFang SC;
      font-weight: 500;
      margin: 0 px2rem(5px);
      p {
        line-height: px2rem(20px);
      }
      .number {
        font-size: px2rem(20px);
        font-family: Helvetica Neue LT Pro;
        font-weight: bold;
      }
    }
  }
}

.slide2 {
  position: relative;
  display: flex;
  flex-direction: column;

  > .img {
    width: 100%;
    height: auto;
    margin-left: px2rem(-2px);
  }
  .desc-wrap {
    width: 100%;
    position: absolute;
    top: 4%;
    text-align: center;
  }
  .desc1 {
    font-size: px2rem(16px);
    font-family: PingFang SC;
    font-weight: 400;
    color: black;
    div:nth-child(1) {
      font-size: px2rem(35px);
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: px2rem(55px);
    }
  }
}
.slide3 {
  width: 100vw;
  background-color: #fafafa;
  .left {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    opacity: 0.7;
    margin: px2rem(40px) auto;
    // padding-left: 4vw;
    div {
      // width: px2rem(35px);
      font-size: px2rem(15px);
      font-family: PingFang SC;
      font-weight: 500;
      color: #000000;
      // display: flex;
      // align-items: center;
      height: px2rem(50px);
      p {
        // width: px2rem(100px);
        padding: px2rem(5px) px2rem(10px);
        text-align: center;
        color: #999999;
        // border: solid 1px black;
        border-radius: px2rem(30px);
      }
      // justify-content: center;
      // p {
      //   width: px2rem(5px);
      //   height: px2rem(5px);
      //   margin-right: px2rem(3px);
      //   background: #000000;
      //   opacity: 0.4;
      //   border-radius: 50%;
      // }
    }
    .active {
      font-weight: 700;
      // font-size: px2rem(17px);
      p {
        background-color: #000000;
        color: #ffffff;
      }
      // p {
      //   width: px2rem(10px);
      //   height: px2rem(10px);
      //   background-color: #fff;
      //   border: px2rem(3px) solid #000000;
      //   border-radius: 50%;
      //   opacity: 1;
      // }
    }
  }
  .right {
    position: relative;
    width: 100%;

    .bold {
      width: 100%;
      text-align: center;
      font-size: px2rem(16px);
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
    }
    .lable {
      width: 100%;
      text-align: center;
      position: absolute;
      margin: 0 auto;
      top: px2rem(80px);
      font-size: px2rem(35px);
      font-weight: 300;
      color: #333333;
    }
    img {
      width: 100%;
    }
  }
}
.slide4 {
  position: relative;
  width: 100vw;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  .box {
    width: 94vw;
    margin: 0 auto;
  }

  .lable {
    width: 100%;
    font-size: px2rem(30px);
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: px2rem(80px);
    color: #333333;
  }

  .title {
    width: 100%;
    // height: max-content;
    height: px2rem(20px);
    // background-color: #000000;
    color: #ffffff;
    // text-align: center;
    position: relative;
    // padding: px2rem(20px) 0;
    p {
      position: absolute;
      top: px2rem(275px);
      width: 100%;
      text-align: center;
      // left: 50%;
      // transform: translate(-50%, -50%);
      font-size: px2rem(26px);
      font-family: PingFang SC;
      font-weight: 500;
      line-height: px2rem(40px);
    }
    div {
      position: absolute;
      top: px2rem(315px);
      // left: 50%;
      width: 100%;
      // transform: translate(-50%, -50%);
      text-align: center;
      font-size: px2rem(16px);
      font-weight: 500;
      margin: 0 auto;
      line-height: px2rem(20px);
    }
  }
  img {
    width: 100%;
    height: auto;
  }
}
.slide5 {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  .bold {
    // font-weight: bold;
    font-weight: 600;
    line-height: px2rem(30px);
    font-size: px2rem(20px);
    color: #000;
  }
  .top {
    position: relative;
    text-align: center;
    img {
      width: 100%;
      height: auto;
    }

    .title {
      padding: px2rem(25px) 0 px2rem(10px);
      width: 100vw;
      height: max-content;
      text-align: center;
      font-size: px2rem(32px);
      font-family: PingFang SC;
      font-weight: 300;
      color: #000000;
    }
    p {
      width: 90%;
      font-size: px2rem(16px);
      margin: px2rem(45px) auto;
      color: #333333;
    }
    hr {
      margin: 0 auto;
      width: 90%;
    }
  }
  .bottom {
    width: 90%;
    font-size: px2rem(10px);
    font-family: PingFang SC;
    div {
      width: 100%;
      margin: px2rem(20px) 5vw;
      p {
        margin-top: px2rem(15px);
        font-size: px2rem(14px);
        line-height: px2rem(25px);
        color: #333333;
      }
    }

    img {
      width: 100%;
      height: auto;
    }
  }
}

.slide6 {
  // background: #f8f8f8;
  position: relative;
  .bold {
    font-size: px2rem(20px);
    line-height: px2rem(40px);
    font-weight: 600;
    color: #000;
  }
  .title {
    padding-top: px2rem(40px);
    width: 100vw;
    text-align: center;
    font-size: px2rem(32px);
    font-family: PingFang SC;
    font-weight: 300;
    color: #000000;
  }

  .bottom {
    margin-top: px2rem(15px);
    padding-bottom: px2rem(40px);
    font-size: px2rem(16px);
    font-family: PingFang SC;
    font-weight: 300;
    div {
      position: relative;
      width: 100vw;
      margin: px2rem(25px) 0 0;
      color: #999999;
      p {
        width: 100vw;
        height: max-content;
        text-align: center;
        background-color: #fff;
        padding: 0 px2rem(30px) px2rem(30px);
        line-height: px2rem(26px);
      }
    }

    img {
      width: 100%;
      height: auto;
    }
  }
}

.slide7 {
  position: relative;
  width: 100vw;
  div {
    width: 100%;
    font-size: px2rem(20px);
    font-family: PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: px2rem(35px);
    .title1 {
      position: absolute;
      top: px2rem(10px);
      left: px2rem(10px);
    }
    .title2 {
      position: absolute;
      font-weight: 700;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: px2rem(30px);
    }
    .title3 {
      position: absolute;
      bottom: px2rem(10px);
      right: px2rem(10px);
      font-size: px2rem(16px);
    }
  }
  img {
    width: 100vw;
    height: auto;
  }
}
.slide8 {
  width: 100vw;
  margin-bottom: 5vh;
  .skeleton {
    width: 100vw;
    margin: 0 auto;
    text-align: center;
    img {
      width: 70%;
    }
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: px2rem(22px);
    margin: px2rem(22px) 0;
  }
  .icon {
    width: 100vw;
    padding: 3vw 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    div {
      display: inline-block;
      width: 40vw;
      height: auto;
      text-align: center;
      border: #000000 solid px2rem(2px);
      border-radius: px2rem(6px);
      padding: 1vw 0;
      margin: 3vw;
      font-size: px2rem(14px);
      font-family: PingFang SC;
      font-weight: 400;
      .bold {
        font-size: px2rem(14px);
        font-weight: 400;
      }
      .text {
        height: px2rem(40px);
        margin: px2rem(6px) 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: center;
      }

      img {
        width: 30%;
        margin: 3vw 0 1vw;
      }
    }
  }
  .content {
    width: 90vw;
    height: auto;
    margin: px2rem(5px) auto;
    // background-color: #f7f7f7;
    text-align: center;
    font-size: px2rem(14px);
    font-family: PingFang SC;
    padding: px2rem(5px) 0;
    div {
      display: flex;
      // justify-content: center;
      align-content: center;
      margin: px2rem(20px) 0;
      li {
        margin: 0 px2rem(5px);
        padding: px2rem(5px) 0;
        flex: 1;
        text-align: center;
        border: solid 1px black;
      }
    }
    .bold {
      font-size: px2rem(18px);
      font-family: PingFang SC;
      font-weight: bold;
      line-height: px2rem(30px);
    }
  }
}
.slide9 {
  position: relative;
  display: flex;
  flex-direction: column;

  > .img {
    width: 100%;
    height: auto;
  }
  .desc-wrap {
    width: 100%;
    position: absolute;
    text-align: center;
    .desc1 {
      font-size: px2rem(20px);
      font-family: PingFang SC;
      color: black;
      margin-top: px2rem(15px);
    }
    .desc2 {
      margin-top: px2rem(20px);
      width: 100%;
      padding: 0 px2rem(10px);
      display: flex;
      justify-content: space-evenly;
      div {
        flex: 1;
        text-align: left;
        padding-left: px2rem(12px);
        font-size: px2rem(12px);
        font-weight: 400;
        font-family: PingFang SC;
        color: #fff;
      }
      img {
        width: px2rem(25px);
      }
    }
  }
}
.slide10 {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: px2rem(7px);
  .desc1 {
    text-align: center;
    line-height: px2rem(50px);
    font-size: px2rem(20px);
    font-family: PingFang SC;
    color: black;
  }
  .desc2 {
    display: flex;
    flex-wrap: wrap;
    gap: px2rem(7px); /* 设置图片之间的间距 */
    div {
      flex: 1 1 calc(50% - 7px); /* 每个子项占据50%宽度，并减去间距 */
      display: flex;
      justify-content: end;
      align-items: end;
      p {
        position: absolute;
        font-size: px2rem(15px);
        font-family: PingFang SC;
        color: #fff;
        padding: 0 px2rem(5px) px2rem(5px) 0;
      }
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.slide11 {
  position: relative;
  display: flex;
  flex-direction: column;

  > .img {
    width: 100%;
    height: auto;
  }
  .desc-wrap {
    width: 100%;
    position: absolute;
    .desc1 {
      float: right;
      width: 53%;
      padding: px2rem(15px) px2rem(5px) 0 0;
      font-size: px2rem(14px);
      p {
        font-size: px2rem(16px);
        font-weight: 700;
      }
      div {
        margin: px2rem(5px) 0;
      }
    }
  }
}
.slide12 {
  background: rgb(250, 250, 250);
  div {
    display: flex;
    li {
      padding: 0 px2rem(5px);
      margin: px2rem(5px);
      background-color: rgba(255, 255, 255, 1);
      flex: 1;
      font-size: px2rem(16px);
      text-align: center;
      img {
        width: px2rem(30px);
      }
      p {
        margin: px2rem(10px);
      }
    }
  }
  .title {
    justify-content: center;
    font-size: px2rem(22px);
    margin: px2rem(22px) 0;
  }
}
</style>
